import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AppTokenHandler {
    public access_token_key = 'access_token';
    access_token_value = '';
    public Azure_token_key = 'Azure_token';
    Azure_token_value = '';
    loginUserInfo: UserInfo;
    private isAuthenticated = new BehaviorSubject<boolean>(false);

    constructor(private cookieService: CookieService)
    {
      this.cookieService = inject(CookieService);
    }
    getSessionToken() {
        if (sessionStorage.length > 0) {
            this.access_token_value = sessionStorage.getItem(this.access_token_key);
        }
        if (this.access_token_value == null) {
            this.access_token_value = '';
        }
        return this.access_token_value;
    }

    setSessionToken(loginData) {
        this.isAuthenticated.next(true);
        this.access_token_value = loginData.TokenID;
        sessionStorage.setItem('UserInfo', JSON.stringify(loginData));
        sessionStorage.setItem(this.access_token_key, this.access_token_value);
    }

    clearSessionToken() {
        this.isAuthenticated.next(false);
        sessionStorage.removeItem(this.access_token_key);
        sessionStorage.clear();
    }

    getLoginUserInfo() {
        this.loginUserInfo = JSON.parse(sessionStorage.getItem('userDetails'));
        return this.loginUserInfo;
    }

    getAzureTokenFromLocalStorage() {
      if (localStorage.length > 0) {
          this.Azure_token_value = this.cookieService.get(this.Azure_token_key) || '';

      }
      if (this.Azure_token_value == null) {
          this.Azure_token_value = '';
      }
      return this.Azure_token_value;
  }
  setAzureTokenLocalStorage(azuretoken: any) {
    this.Azure_token_value = azuretoken;

    this.cookieService.set(this.Azure_token_key, this.Azure_token_value);
}
clearAllAzureCookie() {
  this.cookieService.delete(this.Azure_token_key);
  this.cookieService.deleteAll();
}

get isLoggedIn() {
  return this.isAuthenticated.value;
}
}

export class UserInfo {
    FullName: string;
    IdentityDomain: string;
    IdentityName: string;
    IsAuthenticated: boolean;
    LotusUserEmailID: string;
    NetworkId: string;
    TokenID: string;
    UserAppRoles: any;
    UserCurrentRole: string;
    UserEmailID: string;
    UserGPN: string;
    UserHasAccess: boolean;
}

@Injectable()
export class HTTPStatus {
    private requestInFlight$: BehaviorSubject<boolean>;
    constructor() {
        this.requestInFlight$ = new BehaviorSubject(false);
    }

    setHttpStatus(inFlight: boolean) {
        this.requestInFlight$.next(inFlight);
    }

    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }

}
